/* Wrapper component for showing all the product tiles */
/* Can use either only this component and pass the items to it or use the single ProductTile component directly */

import ProductTile from "./ProductTile";
import { useEffect, useState } from 'react';
import styles from "../Basket.module.scss";

export default function ProductTileList({ lineItems, isMobile }) {
  //isOnlyPreorder array is created for preorder products
  const [isOnlyPreorder, setIsOnlyPreorder] = useState([]);
  //isOnlyAvailable array is created for available products
  const [isOnlyAvailable, setIsOnlyAvailable] = useState([]);

  useEffect(() => {
    //reset array to null to avoid garbage data
    setIsOnlyPreorder([]); 
    setIsOnlyAvailable([]);
    try {
      lineItems?.filter((item) => {
        //if a product has tag Availability:Pre-order add it in preorder array else add it in available array.
        if (item?.node?.merchandise?.product?.tags?.includes("Availability:Pre-order")) {
          setIsOnlyPreorder(isOnlyPreorder => [...isOnlyPreorder, item]);
        }
        else {
          setIsOnlyAvailable(isOnlyAvailable => [...isOnlyAvailable, item]);
        }
      })
    } catch (err) {
      console.log(err, "Availablity tag error");
    }
    
  }, [lineItems]);

  //display of preorder productlist
  const preProductTiles = isOnlyPreorder?.map((item, index) => {
    return <>
      <ProductTile id={index} key={item?.node?.merchandise?.id} productInfo={item.node} isMobile={isMobile} />
    </>
  })?.reverse();

  //display of available productlist
  const availableProductTiles = isOnlyAvailable?.map((item, index) => {
    return <>
      <ProductTile id={index} key={item?.node?.merchandise?.id} productInfo={item.node} isMobile={isMobile} />
    </>
  })?.reverse();
    
  return <>
    <>
      {/* shows only available products */}
      {isOnlyAvailable?.length > 0 && isOnlyPreorder?.length == 0 ? availableProductTiles:""}
    </>
    <>
      
    {/* shows available products with title Available*/}
    {
      isOnlyAvailable?.length > 0 && isOnlyPreorder?.length > 0 ?
      <>
        <div className={`${styles.preorder} small-md small-sm x-small-xs medium`}>Available now</div> 
        {availableProductTiles}
      </> : ""
    }    
      
    {/* shows preorder products with title Preorder*/}
    {
      isOnlyPreorder?.length > 0 ?
      <>
        <div className={`${styles.preorder} small-md small-sm x-small-xs medium`}>Pre-order</div> 
        {preProductTiles}
          </> : ""
    }
      
    </>
  </>;

}


